import { isReservedTenantSlug, isValidTenantSlug } from './slug';

export const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'smartcampus.africa';

function normalizeHostname(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, '');
}

export function getHostnameContext(rawHostname = window.location.hostname) {
  const hostname = normalizeHostname(rawHostname);
  const rootDomain = normalizeHostname(ROOT_DOMAIN);
  const rootAlias = `www.${rootDomain}`;

  if (!hostname || hostname === 'localhost') {
    return {
      hostname: hostname || 'localhost',
      rootDomain,
      isLocalhost: true,
      isRootDomain: true,
      isSubdomain: false,
      isRootAlias: false,
      tenantSlug: null,
      reservedSlug: null,
    };
  }

  if (hostname.endsWith('.localhost')) {
    const tenantSlug = hostname.replace(/\.localhost$/, '');
    return {
      hostname,
      rootDomain: 'localhost',
      isLocalhost: true,
      isRootDomain: false,
      isSubdomain: Boolean(tenantSlug),
      isRootAlias: false,
      tenantSlug: tenantSlug || null,
      reservedSlug: null,
    };
  }

  if (hostname === rootDomain || hostname === rootAlias) {
    return {
      hostname,
      rootDomain,
      isLocalhost: false,
      isRootDomain: true,
      isSubdomain: false,
      isRootAlias: hostname === rootAlias,
      tenantSlug: null,
      reservedSlug: hostname === rootAlias ? 'www' : null,
    };
  }

  if (!hostname.endsWith(`.${rootDomain}`)) {
    return {
      hostname,
      rootDomain,
      isLocalhost: false,
      isRootDomain: false,
      isSubdomain: false,
      isRootAlias: false,
      tenantSlug: null,
      reservedSlug: null,
    };
  }

  const tenantSlug = hostname.slice(0, -(rootDomain.length + 1));
  const validTenantSlug = isValidTenantSlug(tenantSlug) ? tenantSlug : null;
  const reservedSlug = isReservedTenantSlug(tenantSlug) ? tenantSlug : null;

  return {
    hostname,
    rootDomain,
    isLocalhost: false,
    isRootDomain: false,
    isSubdomain: true,
    isRootAlias: false,
    tenantSlug: validTenantSlug,
    reservedSlug,
  };
}
